import React from "react";
import { staticDb } from "../../../../staticData/db";
import { Menu, MenuGroupItem } from "../../Menu/Menu";
import { Sidebar, SidebarRegion, Content } from "reactackle";
import MediaQuery from "react-responsive";
import moment from "moment";

let oldObj = {
  deliveryRequest: {
    caption: "ORDER"
  },
  signout: {
    caption: "SIGN OUT"
  }
};

let menuList = Object.keys(oldObj).map(key => {
  return {
    tableName: key,
    menuCaption: oldObj[key].caption,
    tableCaption: oldObj[key].caption
  };
});

//console.log("oldObj: " + JSON.stringify(oldObj));
//console.log("menuList: " + JSON.stringify(menuList));

export const getMenuList = (
  smallerMedia,
  isAdmin,
  switchMenuHandler,
  currUserRole,
  allMenusFromDb
) => {
  let allMenus = {};
  //console.log("allMenusFromDb: " + JSON.stringify(allMenusFromDb));
  if (allMenusFromDb && allMenusFromDb !== undefined) {
    //console.log("got full list of menus");

    allMenus = allMenusFromDb;
  } else {
    //console.log("depending on static menu");
    allMenus = menuList;
  }

  //console.log(JSON.stringify(allMenus));

  //console.log("All Menu: " + JSON.stringify(allMenus));
  if (smallerMedia === true) {
    return allMenus.map(item => {
      if (
        item &&
        (item.displayToggle === "YES" || item.displayToggle === undefined)
      ) {
        return (
          <div
            style={{
              paddingLeft: "5px"
            }}
          >
            <div
              href="#"
              onClick={() => switchMenuHandler(item.tableName)}
              style={{
                marginLeft: "3px",
                color: "black"
              }}
            >
              <span
                style={{
                  width: "20px"
                }}
              >
                {item.menuIcon && item.menuIcon !== "" && (
                  <icon
                    className={item.menuIcon}
                    style={{
                      border: "1px solid gainsboror",
                      padding: "5px"
                    }}
                  />
                )}
              </span>
              <span>{item.menuCaption}</span>
            </div>
            <hr
              style={{
                margin: "5px"
              }}
            />
          </div>
        );
      }
    });
  } else {
    return allMenus.map(item => {
      if (item.displayToggle === "YES" || item.displayToggle === undefined) {
        return (
          <MenuGroupItem
            linkHref="/"
            text={item.menuCaption}
            onPress={() => switchMenuHandler(item.tableName)}
          />
        );
      }
    });
  }
};

export const getSideBar = (
  smallerMedia,
  isAdmin,
  switchMenuHandler,
  currUserRole,
  allMenusFromDb
) => {
  return (
    <MediaQuery minDeviceWidth={768}>
      <Sidebar
        autoCollapsing={true}
        haveToggleButton={true}
        toggleButtonText={"Collapse"}
        attachToRight={false}
        outlined
        style={{ backgroundColor: "white" }}
      >
        <SidebarRegion>
          <Menu>
            <Content>
              {getMenuList(
                smallerMedia,
                isAdmin,
                switchMenuHandler,
                currUserRole,
                allMenusFromDb
              )}
            </Content>
          </Menu>
        </SidebarRegion>
      </Sidebar>
    </MediaQuery>
  );
};

export const getEnrichedObject = (ogObj, searchObj, userProfile) => {
  let newObj = {};
  for (let key in ogObj) {
    let word = ogObj[key];
    // console.log(
    //   "key: " + key + " value: " + word + " userProfile: " + userProfile[word]
    // );
    if (word) {
      if (searchObj[word] && searchObj[word] !== undefined) {
        newObj[key] = searchObj[word];
      } else if (word === "currentDate") {
        newObj[key] = moment().format("DD-MM-YYYY");
      } else if (word === "currentDateTime") {
        newObj[key] = moment().format("DD-MM-YYYY h:mm a");
      } else if (userProfile[word] && userProfile[word] !== undefined) {
        newObj[key] = userProfile[word];
      } else {
        newObj[key] = word;
      }
    }
  }
  //console.log("~~here is newObj: " + JSON.stringify(newObj));
  return newObj;
};

const getInitForOgDef = fields => {
  let initRec = fields.reduce((prevValue, currValue, currIndex, fullArray) => {
    if (prevValue !== 0) {
      prevValue[currValue.name] =
        currValue.defaultValue && currValue.defaultValue !== undefined
          ? currValue.defaultValue
          : "";
      return prevValue;
    } else {
      prevValue = {};
      prevValue[currValue.name] =
        currValue.defaultValue && currValue.defaultValue !== undefined
          ? currValue.defaultValue
          : "";
      return prevValue;
    }
  }, 0);
  //console.log("~~here is initRec: " + JSON.stringify(initRec));
  return initRec;
};

export const getInitData = (tableName, createTableList, currentProfile) => {
  let initData = undefined;
  //console.log("Table name for init: " + tableName);

  //console.log("Init name for init: " + initName);
  initData = staticDb[tableName];
  //console.log("~~ Init data is: " + JSON.stringify(initData));
  if (!initData || initData === undefined) {
    if (createTableList && createTableList.length > 0) {
      let currDefs = createTableList.find(item => item.name === tableName);
      //console.log("currDefs: " + JSON.stringify(currDefs));
      if (currDefs && currDefs["fields"]) {
        initData = getInitForOgDef(currDefs["fields"]);
      }
    }
  }
  if (initData && initData !== undefined) {
    initData = getEnrichedObject(initData, {}, currentProfile);
  }

  return initData;
};

export const getCaption = (tableName, listOfTables, isMobile) => {
  if (
    tableName &&
    tableName !== "" &&
    listOfTables &&
    listOfTables.length > 0
  ) {
    let tgtMenu = listOfTables.find(item => item.name === tableName);
    if (tgtMenu && tgtMenu !== undefined) {
      if (isMobile) {
        // return _.truncate("long text to be truncated", {
        //   length: 250,
        //   separator: " "
        // });
        if (tgtMenu.caption !== "" && tgtMenu !== null) {
          if (tableName === "users") {
            return "WELCOME TO BCS";
          } else {
            return tgtMenu.caption.slice(0, 21);
          }
        } else {
          return "";
        }
      } else {
        if (tableName === "users") {
          return "WELCOME TO BCS";
        } else {
          return tgtMenu.caption;
        }
      }
    } else {
      return "";
    }
  } else {
    return "";
  }
};



// WEBPACK FOOTER //
// ./src/app/components/Screens/landingPage/getMenuList.jsx